// extracted by mini-css-extract-plugin
module.exports = {"text":"PotentialProfileMessageForm_text__cuA32"};